<!-- Responsibility: Implement vessel definition surface behavior for the ui/components/wizard surface.
Scope: Owns ui/components/wizard concerns only; cross-surface orchestration is excluded. -->
<vessel-definition-surface>
  <div class="wizard-group">
    <header class="wizard-header">
      <div class="wizard-intro">
        <span class="kicker">VESSEL DEFINITION</span>
        <strong>{ props.view.importedPlayer ? 'Imported vessel profile' : 'Define the vessel you will inhabit' }</strong>
        <p>{ props.view.importedPlayer ? 'Imported values are loaded below. Refine anything before the forge.' : 'Identity, lineage, sex, and biography.' }</p>
      </div>
    </header>

    <div class="group">
      <p if={ props.view.importedPlayer } class="note">Using imported vessel profile.</p>

      <div>
        <label class="label">Vessel Name</label>
        <input name="name" type="text" placeholder="e.g. Juki" autocomplete="off" required value={ props.draft?.name || '' }>
      </div>

      <div>
        <label class="label">Vessel Identity</label>
        <input name="identity" type="text" placeholder="e.g. Wandering Librarian" autocomplete="off" required value={ props.draft?.identity || '' }>
      </div>

      <div>
        <label class="label">Lineage / Species</label>
        <input name="lineage" type="text" placeholder="e.g. Human, Pokos, Construct-born" autocomplete="off" value={ props.draft?.lineage || '' }>
      </div>

      <div>
        <label class="label">Sex</label>
        <select name="sex" value={ props.draft?.sex || '' }>
          <option value="">Unspecified</option>
          <option value="female">female</option>
          <option value="male">male</option>
        </select>
      </div>

      <div>
        <label class="label">Biography & Phenomena</label>
        <textarea name="bio" placeholder="Deep history, persistent conditions..." required value={ props.draft?.bio || '' }></textarea>
      </div>
    </div>
  </div>

  <style>
    .wizard-group {
      display: grid;
      gap: var(--space-md);
      animation: wizard-fade-in 0.3s ease-out;
    }

    .wizard-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: var(--space-md);
    }

    .wizard-intro {
      display: grid;
      gap: 0.2rem;
    }

    .kicker {
      font-size: var(--type-3xs);
      letter-spacing: 0.15em;
      color: var(--brand-primary);
      font-weight: 800;
    }

    .wizard-intro strong {
      font-size: var(--type-md);
      color: var(--text-prose);
    }

    .wizard-intro p {
      font-size: var(--type-xs);
      color: var(--text-muted);
      margin: 0;
    }

    .note { font-size: var(--type-xs); color: var(--brand-primary); font-weight: bold; }


    @media (max-width: 45rem) {
      .wizard-header { flex-direction: column; }
    }
  </style>
</vessel-definition-surface>
